import api from './api';
import { attach } from './sso';
import * as Sentry from '@sentry/browser';

export function login(params) {
    return attach()
        .then(() => api.post('/login', params))
        .then(res => {

            Sentry.configureScope(scope => {
                scope.setUser({ id: res.id });
            });

            return res;
        });
}

export function logout() {
    return attach()
        .then(() => api.post('/logout'))
        .then(res => {

            Sentry.configureScope(scope => {
                scope.setUser(null);
            });

            return res;
        });
}

export function getCountryCode() {
    return api.get('/country-code');
}